import React from 'react'
import PropTypes from 'prop-types'

import DimensionChartState from '../components/dimension-chart-state'

const DimensionChart = ({
  data, faded, selected, selectedHandler
}) => {
  // summed up the current value.
  const total = data.reduce(((sum, state) => sum + state.currentValue), 0)
  // cloned the data array and sort in desc by other value.
  const dataByOther = data.slice().sort((a, b) => b.otherValue - a.otherValue)
  const average = total / data.length
  const highSpan = (data[0].currentValue > dataByOther[0].otherValue) ?
    data[0].currentValue - average : dataByOther[0].otherValue - average
  const lowSpan = (data[data.length - 1] < dataByOther[dataByOther.length - 1].otherValue) ?
    average - data[data.length - 1].currentValue : average - dataByOther[dataByOther.length - 1].otherValue
  const span = (highSpan > lowSpan) ? highSpan * 2 : lowSpan * 2
  const stateCharts = data.map((state, index) => (
    <DimensionChartState
      {...state}
      selected={selected.includes(state.state)}
      faded={faded.includes(state.state)}
      selectedHandler={
        (selectedState) => {
          if (selected.includes(selectedState)) {
            selected.splice(selected.indexOf(selectedState), 1)
            selectedHandler(selected)
          } else {
            selectedHandler([...selected, selectedState])
          }
        }
      }
      span={span}
      average={average}
      index={index}
      key={index}
    />
  ))
  return (
    <div className="cmwf--performance-chart-data">
      <div className="cmwf--performance-chart-national-average">
        <span className="cmwf--performance-chart-label average">U.S. Average</span>
      </div>
      <div className="cmwf--performance-chart-legend">
        <span className="cmwf--performance-chart-label better">Better<span> Performance</span></span>
        <span className="cmwf--performance-chart-label worse">Worse<span> Performance</span></span>
      </div>
      {stateCharts}
    </div>
  )
}

DimensionChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  faded: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedHandler: PropTypes.func.isRequired,
}

export default DimensionChart



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/dimension-chart.jsx